import authHeaders from 'helpers/auth-header';
import request from './api';

function getRoles(identificationNumber) {
  return request({
    url: `/role/identification-number/${identificationNumber}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getRoleById(roleId) {
  return request({
    url: `/role/id/${roleId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function addRole(identificationNumber, body) {
  return request({
    url: `/role/identification-number/${identificationNumber}`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}

function editRole(roleId, body) {
  return request({
    url: `/role/id/${roleId}`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}

function deleteRole(roleId) {
  return request({
    url: `/role/id/${roleId}`,
    headers: authHeaders(),
    method: 'DELETE',
  });
}

function getAuthorities(/* roleId */) {
  return request({
    // url: `role/authorities/role-id/${roleId}`,
    url: `authority/all/INDIVIDUAL`,
    headers: authHeaders(),
    method: 'GET',
  });
}

const role = {
  getRoleById,
  getAuthorities,
  getRoles,
  addRole,
  editRole,
  deleteRole,
};

export default role;
